/**
 * RU on all settings including whitelisting
 * This is in common as all apps would need it
 * Setting Key value pairs come from db of the app.
 */
import { CaseFieldComponent } from '../appComponent'
import { Entity } from '../common/base/entity/entity'
// import {EntityComponent} from '../entity'
import { collectionSchemas, entitySchema, methodSchemas } from './caseField.schema'
import { CaseFieldAction } from './CaseFieldAction'
// import {    baseConstants} from '../../entity';

/**
 * Instructions: 
 * 1. For simple usage steps:
 * a. fieldsMeta, actionsMeta, screens, sectionsMeta definition and creation of BaseEntity obj with these inputs
 * 2. For simple overrides of baseEntity 
 * a. create an extended class of baseEntity and override its methods...
 * 3. For more customization
 * a. create a derived Service, derived actions and use them in derived BasedEntity class.
 * b. for component customization pass those components to the constuctor of derived BaseEntity class. SearchList component is the root component.
 *
 * 
 */


class caseFieldEntity extends Entity {
    // override the following if needed.
    // derived actionObj
    // derived Service obj
    // getActionFns if you want to suppress the baseActionobj methods
    // getActionFns() {
    //     let fns = super.getActionFns()
    //     let that = this
    //     return {
    //         ...fns,

    //         addNewItem: (itemData, customerTenantID) => {
    //             // No Create allowed on Settings.
    //             return dispatch => {
    //                 let errorMsg = 'Creating ' + that.name + ' is not allowed'
    //                 dispatch(fns.failure('ADDNEW', errorMsg));
    //                 dispatch(alertActions.error(errorMsg));
    //             }
    //         },
    //         deleteItem: (id, customerTenantID) => {
    //             // No Create allowed on Settings.
    //             return dispatch => {
    //                 let errorMsg = 'Deleting ' + that.name + ' is not allowed'
    //                 dispatch(fns.failure('DELETE', errorMsg));
    //                 dispatch(alertActions.error(errorMsg));
    //             }
    //         }
    //     }
    // }
}

const fieldsMeta = {
    fieldName: {
        label: 'Field Name',
        required: true,
        type: 'text',
        name: 'fieldName',
        placeholder:'Enter Field Name',
        readOnlyOnEdit:true
    },
    fieldProperties_sectionName: {
        label: 'Section',
        min: 3,
        max: 20,
        type: 'select',
        suffix:'fieldProperties',
        required: true,
        placeholder: 'Please Select Section',
        readOnlyOnEdit:true,
        name: 'sectionName'
    },
    fieldType: {
        label: 'Type',
        name: 'type',
        suffix:'fieldProperties',
        required: true,
        type: 'select',
        options: [
            {label: 'Text', value: 'text'}, 
            {label: 'Text Area', value: 'textarea'},
            {label: 'Drop Down', value: 'select'},
            {label: 'Label', value: 'label'}
        ],
        readOnlyOnEdit:true
    },
    fieldProperties_type: {
        label: 'Type',
        name: 'type',
        suffix:'fieldProperties',
        type:'text'

    },
    fieldLabel: {
        label: 'Label',
        name: 'Label',
        required: true,
        type: 'text',
        placeholder:'Enter Field Label'
    },
   
    fieldProperties: {
        label: 'Properties',
        name: 'fieldProperties',
        required: true,
        type: 'textarea',
        placeholder:'Enter Field Properties'
    },
    status: {
        label: "Status",
        name: 'status',
        options: [{label: 'Published', value: 'Published'}],
        type: 'select',
        required: true,
        default: 'Published',
       // width:'10%',

    },
    updatedBy: {
        label: 'Last Edited By',
        name: 'updatedBy',
        // readOnly: true,
        required: true,
        type: 'text'
    },
    updatedBy: {
        label: 'Last Edited By',
        name: 'updatedBy',
        // readOnly: true,
        required: true,
        type: 'text'
    },
    updatedBy: {
        label: 'Last Edited By',
        name: 'updatedBy',
        // readOnly: true,
        required: true,
        type: 'text'
    },
    updatedAt: {
        label: 'Last Edited At',
        name: 'updatedAt',
        // readOnly: true,
        required: true,
        type: 'datetime-local'
    }
}


const actionsMeta = {
    doSomething: {
        type: 'button',
        label: 'Update',
        action: 'editItem',
        name: 'doSomething'
    },
    editMap: {
        label: 'Edit Map',
        name: 'editMap',
        action: 'showMap',
        condition: 'typeof value === "object"',

    },
    save: {
        label: 'Save',
        name: 'save',
        action: 'save'
    },
    cancel: {
        label: 'Cancel',
        name: 'cancel',
        action: 'cancelEdit'
    },
    update: {
        label: 'Update',
        name: 'update',
        action: 'upsertItem',
        classes: 'fa fa-pencil fa-lg ',
        type: 'span'
    },
    list: {
        label: 'List All',
        name: 'list',
        action: 'load'
    },
    search: {
        label: 'Search',
        name: 'search',
        action: 'search'
    },
    view: {
        label: 'View',
        name: 'view',
        action: 'getItem',
        classes: 'fa fa-eye fa-lg',
        type: 'span'
    },
    
     create:{
        label: 'Create',
        name : 'create',
        type: 'button',
        action: 'addNewItem',
    },
    createItem:{
        label: 'Create',
        action: 'upsertItem',
        name : 'create',
        type: 'button'
    },
    deleteConfig:{
        label: 'Delete',
        action: 'editItem',
        name : 'deleteConfig',
        color: 'danger',
        type: 'button'
    },
}
const sectionsMeta = {
    general: {
        items: [{name:'status', type: 'field'}, {name:'updatedBy', type: 'field'}, {name:'updatedAt', type: 'field'}]
    },
    basic: {
        title: 'Field Details',
        items:[
        {name:'fieldname', type: 'field'}, 
        {name:'sectionName', type: 'field'},  
        {name:'fieldType', type: 'field'}, 
        {name:'fieldLabel', type: 'field'}, 
        {name:'fieldProperties', type: 'field'}, 
        {name:'status', type: 'field'}
    ],
        classes:"ticket-form caseField"
    },
    headerComponent: {
        component: 'DetailHeader',
    }

}

const fieldTypeMetaBasic=[
    {label:'Label',name:'label',required:true,placeholder:'Enter Label',type:'text'},
    {label:'Sequence Order',name:'position',placeholder:'Enter Sequence Order',type:'number'}]

const fieldTypeMetaText=[
    {label:'is Required',name:'required',required:true,placeholder:'Enter Label',type:'select',options:[{label: 'True', value: true}, {label: 'False', value: false}]},
    {label:'Placeholder',name:'placeholder',required:true,placeholder:'Enter Placeholder',type:'text'},
    {label:'Validation Message',name:'errorMessage',placeholder:'Enter Validation Message',type:'text'}

]


const fieldTypeMetaSelect=[
    {label:'Static',name:'isStatic',required:true,placeholder:'Select',type:'select',options:[{label: 'True', value: 1}, {label: 'False', value: 0}]},
    {label:'Properties',name:'options',required:true,placeholder:'Enter Properties',type:'textarea', rows:15, parse:true}
]


const fieldTypeMeta = {
       select:[...fieldTypeMetaBasic,...fieldTypeMetaSelect,...fieldTypeMetaText],
       textarea:[...fieldTypeMetaBasic,...fieldTypeMetaText],
       label:fieldTypeMetaBasic,
       text:[...fieldTypeMetaBasic,...fieldTypeMetaText]
}

const screens = {
    // edit: {
    //     title:{label: 'Edit Settings', col: 1, },
    //     items: [{name:'heading', type: 'section'}],
    //     actions: ['editMap', 'cancel', 'save']
    // },
    view: {
        items: [{name:'headerComponent', type: 'section'}, {name: 'queueForm', type: 'section'}],
        // classes: 'composite-form',
        title: 'Queue Details'
    },
    create:{
        items: [{name:'headerComponent', type: 'section'}, {name: 'createForm', type: 'section'}]
    },
    edit:{
        items: [{name:'headerComponent', type: 'section'}, {name: 'queueForm', type: 'section'}]
    },
    // view: {
    //     sections: ['general', 'details'],
    //     actions: ['edit']
    // },
    list: {
        items: [
            {name:'fieldProperties_sectionName', type: 'field'},
            {name:'fieldName', type: 'link'}, 
            {name:'fieldProperties_type', type: 'field'},
            {name:'status', type: 'field'}
        ],
        // actions: ['view', 'update']
        filter : [{
            name: "status",
            operator: "ne",
            value: "Deleted"
        }],
        multiselect:false,
        layoutType:{excluded:{sort:true,paging:true},type:['Grid']}
    }
  
}
// const components = { searchList: EntityComponent} // can overrides the components like this if needed
const caseField = new caseFieldEntity({ActionClass: CaseFieldAction, fieldsMeta, contentMeta:fieldTypeMeta , actionsMeta, sectionsMeta, screens, name: 'CaseField', title: 'Case Field', methodSchemas, collectionSchemas,  entitySchema, idKey: 'id', entityUrlPaths:{ default: "ticketing/CaseField", getOne:"ticketing/CaseField/findAndCountAll", update: "ticketing/CaseField/update" }, fetchDetailByApi: false, appComponent:CaseFieldComponent })

const caseFieldListSearchContainer = caseField.getContainer('ListSearch')
const caseFieldCreateContainer = caseField.getContainer('AppComponent')
const caseFieldDetailContainer = caseField.getContainer('AppComponent')
export { caseFieldListSearchContainer, caseFieldCreateContainer, caseFieldDetailContainer }

